import { useEffect, useMemo } from "react";
import { debounce } from "@evergis/sgis/es/utils/utils";

const DEBOUNCE_DELAY = 144;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useResize = (callback?: (...args: any) => any, delay?: number) => {
  const debounceCallback: VoidFunction | undefined = useMemo(() => {
    return callback ? debounce(callback, delay || DEBOUNCE_DELAY) : undefined;
  }, [callback, delay]);

  useEffect(() => {
    debounceCallback && window.addEventListener("resize", debounceCallback);

    return () => debounceCallback && window.removeEventListener("resize", debounceCallback);
  }, [debounceCallback]);
};
